export const EXTERNAL_INVITATION_ROUTES = {
	ROOT: "/external-invitation",
} as const;
